import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { reactive, toRefs, onBeforeMount, onMounted, watch } from "vue";
import { initFirebaseSw, isFirebaseSwInitialized, saveFirebaseToken } from "../../Firebase/FirebaseMessaging/firebaseMessaging";
//@ts-ignore
import { getURLPage } from "@utils/URLPagesFactory";
//@ts-ignore
import { sendGAEvent } from "@utils/GaEvents";
//@ts-ignore
import { isNotificationDenied } from "@utils/NotificationsUtils";
//@ts-ignore
import { addPermissionStateListener, onNotificationsPermissionChange } from "@utils/permissionUtils";
//@ts-ignore
import { isMobile } from "@utils/DeviceDetection";
//@ts-ignore
import { decodeCookie, encodeCookie } from "@utils/CookieUtils";
//@ts-ignore
import { useLoggedUserStore } from "@store/LoggedUserStore";
export function useFirebaseMessaging() {
  var loggedUserStore = useLoggedUserStore();
  var state = reactive({
    showFirebaseSnackbar: false,
    snackbarTitle: "",
    snackbarBody: "",
    firebaseSwInitialized: false,
    snackbarIcon: null
  });
  var showActivateNotificationsSnackbar = () => {
    var notificationSnackbarCookie = decodeCookie("notificationsSnackbar");
    if (!notificationSnackbarCookie) {
      encodeCookie("notificationsSnackbar", {
        activated: true
      }, 1);
      state.showFirebaseSnackbar = true;
      state.snackbarTitle = "";
      /*TODO: questo purtroppo da mobile bisogna richiedere che l'utente ricarichi la pagina manualmente*/
      if (isMobile())
        //@ts-ignore
        state.snackbarBody = window["_labels"]["enable_browser_notifications_reload"];else
        //In modalità desktop invece si può rilevare il cambio di stato e inizializzare subito il sw
        //@ts-ignore
        state.snackbarBody = window["_labels"]["enable_browser_notifications"];
    }
  };
  var setSnackbarIcon = icon => {
    state.snackbarIcon = icon;
  };
  var setSaveSearchNotificationIcon = () => {
    state.snackbarIcon = {
      src: "_ui/img/Ico/bell-yellow.svg",
      alt: "save search notification"
    };
  };
  var handleOnForegroundNotificationClick = () => {
    sendGAEvent("push_notification_opened", {
      event_location: "Notifica Push - Android_or_Web"
    });
    window.location.href = getURLPage("SAVED_SEARCHES");
  };
  onBeforeMount(() => {
    addPermissionStateListener();
    onNotificationsPermissionChange(_ref => {
      var {
        detail
      } = _ref;
      return __awaiter(this, void 0, void 0, function* () {
        /* asking for permission iff the user is logged. Since this event is triggered too late on mobile devices (on element interaction as click), we will block it! */
        if (!loggedUserStore.isLogged || isMobile()) return;
        /* In case the user has refused initially the notifications, we will listen for a change in the notification state.
        * If he accepts, then we will initialize the service worker
        *  */
        if (detail.permissionState === "granted") {
          if (isFirebaseSwInitialized()) return;
          yield initFirebaseSw();
          yield saveFirebaseToken();
        } else if (["prompt", "denied"].includes(detail.permissionState)) {
          showActivateNotificationsSnackbar();
        }
      });
    });
    document.addEventListener("foreground.message.received", e => {
      state.showFirebaseSnackbar = true;
      state.snackbarTitle = e.detail.title;
      state.snackbarBody = e.detail.body;
    });
    /* Setting some default icons */
    setSaveSearchNotificationIcon();
  });
  onMounted(() => {
    watch(() => loggedUserStore.isUserLogged, (cur, prev) => __awaiter(this, void 0, void 0, function* () {
      if (!cur) {
        return;
      }
      /* Initializing the firebase sw iff the user is logged! */
      if (!isFirebaseSwInitialized()) {
        yield initFirebaseSw();
      }
      // we need always to save the token when the user logs in if we want that he receives the notifications
      yield saveFirebaseToken();
      //And has at least one active notification request, we want to tell him to activate the browser notifications if he did not
      if (isNotificationDenied()) {
        showActivateNotificationsSnackbar();
      }
    }));
  });
  return Object.assign(Object.assign({}, toRefs(state)), {
    handleOnForegroundNotificationClick
  });
}